import { message } from "antd";
import { gatewayInstance } from "../server/gateway";
import { IClientConfig, IPermissions } from "../types/common";
import { FocusSDK as focusSDK, isFocusEnv } from "@/utils";
import { AuthData } from "@/types/LocalConfig";
import { UserTeamInfoInterface } from "@/types/LoginPage";

/**
 *
 * 用户订阅
 * @param {Schedule} schedule
 * @returns
 */
export async function getUserProfile(body: any = {}) {
  return gatewayInstance.request({
    api: "login.getUserProfile",
    method: "POST",
    // @ts-ignore
    body
  });
}

export async function getMapAccountList(body: any = {}) {
  return gatewayInstance
    .request({
      api: "login.getMapAccountList",
      method: "POST",
      // @ts-ignore
      body
    })
    .then((res) => res)
    .catch((err) => {
      message.error(err.message);
    });
}

export function permissionRequest() {
  return gatewayInstance.request<IPermissions[]>({
    api: "abacAuthService.getAuthoritiesAndResources",
    // api: 'authz.getAuthoritiesAndResources',
    method: "POST",
    body: {}
  });
}

// 获取能否创建专班的权限
export async function getPermission() {
  let res: any = [];
  if (isFocusEnv()) {
    const authInfo = focusSDK.authInfo as AuthData;
    console.log("authInfo--", authInfo);
    const userKey = `${authInfo.userId}:${authInfo.ddAppId}:${authInfo.selectedTeamId}`;
    try {
      res = await permissionRequest();
      focusSDK.setBaseAuthorityData({
        key: "abacAuth",
        userKey,
        data: {
          data: res
        }
      });
    } catch (e) {
      focusSDK.printLog("读取权限接口出错", e);
      res = await focusSDK.getBaseAuthorityData({
        key: "abacAuth",
        userKey
      });
      res = res || [];
      focusSDK.printLog("读取本地权限", JSON.stringify(res));
    }
  } else {
    try {
      res = await permissionRequest();
    } catch (e) {
      res = [];
    }
  }
  return res;
}
// 获取会议优先级和埋点开启权限
export function permission2Request(params: any) {
  return gatewayInstance.request<IPermissions[]>({
    api: "abacAuthService.checkAuthoritiesAndResources",
    method: "POST",
    body: {
      productActions: params
    }
  });
}

export async function getPermission2(params: any) {
  let res: any = [];
  if (isFocusEnv()) {
    const authInfo = focusSDK.authInfo as AuthData;
    const userKey = `${authInfo.userId}:${authInfo.ddAppId}:${authInfo.selectedTeamId}`;
    try {
      res = await permission2Request(params);
      focusSDK.setBaseAuthorityData({
        key: "checkAuth",
        userKey,
        data: {
          data: res
        }
      });
    } catch (e) {
      focusSDK.printLog("读取视频权限接口出错", e);
      res = await focusSDK.getBaseAuthorityData({
        key: "checkAuth",
        userKey
      });
      res = res || [];
      focusSDK.printLog("读取视频本地权限", JSON.stringify(res));
    }
  } else {
    try {
      res = await permission2Request(params);
    } catch (e) {
      res = [];
    }
  }
  return res;
}

export function clientConfigRequest() {
  return gatewayInstance.request<IClientConfig>({
    api: "focus.clientConfig",
    // api: 'authz.getAuthoritiesAndResources',
    method: "POST",
    body: {}
  });
}

// 获取使用jd语音权限
export async function getClientConfig() {
  let res: any = [];
  if (isFocusEnv()) {
    const authInfo = focusSDK.authInfo as AuthData;
    console.log("authInfo--", authInfo);
    const userKey = `${authInfo.userId}:${authInfo.ddAppId}:${authInfo.selectedTeamId}`;
    try {
      res = await clientConfigRequest();
      console.log("jdAudioPermissionRequest=>", res);
      // focusSDK.setBaseAuthorityData({
      //   key: "jdAudio",
      //   userKey,
      //   data: {
      //     data: res
      //   }
      // });
    } catch (e) {
      // focusSDK.printLog("读取权限接口出错", e);
      // res = await focusSDK.getBaseAuthorityData({
      //   key: "abacAuth",
      //   userKey
      // });
      // res = res || [];
      // focusSDK.printLog("读取本地权限", JSON.stringify(res));
    }
  }
  return res;
}

// 是否是团队管理员
export function getTeamAdmin() {
  return gatewayInstance
    .request({
      api: "authz.determineAdministrator",
      method: "POST",
      body: {}
    })
    .then((res: any) => {
      return { result: res.result };
    })
    .catch(() => ({
      result: []
    }));
}

export async function updatePwdReq(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focus.setPassword",
      method: "POST",
      body
    })
    .catch((err) => {
      message.error(err.message);
    });
}

export async function updateBindMobileReq(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focus.updateBindMobile",
      method: "POST",
      body
    })
    .catch((err) => {
      message.error(err.message);
    });
}

export async function syncEmplMobile(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focus.syncEmplMobile",
      method: "POST",
      body
    })
    .catch((err) => {
      message.error(err.message);
    });
}

export async function updateBindEmailReq(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focus.updateBindEmail",
      method: "POST",
      body
    })
    .catch((err) => {
      message.error(err.message);
    });
}
export async function bindEmailReq(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focus.bindEmail",
      method: "POST",
      body
    })
    .catch((err) => {
      message.error(err.message);
    });
}

export async function verifyCodeReq(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focus.verifyCode",
      method: "POST",
      body
    })
    .catch((err) => {
      message.error(err.message);
    });
}

export async function unbindEmailReq(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focus.unBindEmail",
      method: "POST",
      body
    })
    .catch((err) => {
      message.error(err.message);
      throw err;
    });
}

export async function verifyPwdReq(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focus.verifyPassword",
      method: "POST",
      body
    })
    .catch((err) => {
      message.error(err.message);
    });
}

export async function changeAvatarReq(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focus.changeAvatar",
      method: "POST",
      body
    })
    .catch((err) => {
      message.error(err.message);
    });
}

export async function getAuthorizationCode(opts: any): Promise<[any, string | null]> {
  try {
    const data = await gatewayInstance.request({
      api: "eopen.getCode",
      method: "POST",
      body: {
        ...opts
      }
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

export async function updateEmplMobileSubmit(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focusadmin.enterprise.address.updateEmplMobileSubmit",
      method: "POST",
      body
    })
    .then((res) => res)
    .catch((err) => {
      message.error(err.message);
    });
}

export async function getEmployeeDetailByUserIdForEbook(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focusadmin.enterprise.address.getEmployeeDetailByUserIdForEbook",
      method: "POST",
      body
    })
    .then((res) => res)
    .catch((err) => {
      message.error(err.message);
    });
}

export async function updateEmplInfoSubmit(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focusadmin.enterprise.address.updateEmplInfoSubmit",
      method: "POST",
      body
    })
    .then((res) => res)
    .catch((err) => {
      message.error(err.message);
    });
}

// 端上查询公共账号审计日志
export async function getCommonAccountUserLogListForWeb(body: any): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "focusadmin.enterprise.audit.getCommonAccountUserLogListForWeb",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 端上查询管理日志
export async function getAuditByPageForWeb(body: any): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "focusadmin.enterprise.audit.getAuditByPageForWeb",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 踢出公共账号登录用户
export async function kikeDeviceForPublicAccount(publicAccountUserId: string): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "login.kikeDeviceForPublicAccount",
      method: "POST",
      body: { publicAccountUserId }
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 查询配置
export async function queryClientConfig(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focusadmin.enterprise.config.queryConfig",
      method: "POST",
      body
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      message.error(err.message);
    });
}

// 版本号获取
export async function queryClientConfigVersion(body: any = {}) {
  return gatewayInstance
    .request({
      api: "focusadmin.enterprise.config.queryConfigWithVersion",
      method: "POST",
      body
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      message.error(err.message);
    });
}
// 生成二维码以及邀请码
export function generateTeamCode(params: any) {
  return gatewayInstance.request<any>({
    api: "focus.generateTeamCode",
    method: "POST",
    body: {
      ...params
    }
  });
}
// 刷新二维码以及邀请码
export function refreshTeamCode(params: any) {
  return gatewayInstance.request<any>({
    api: "focus.generateTeamCode",
    method: "POST",
    body: {
      ...params
    }
  });
}
// 租户获取
// 导出异步函数 getUserTeamInfo，用于获取用户团队信息
export async function getUserTeamInfo() {
  // 通过 gatewayInstance 发起请求
  return (
    gatewayInstance
      // 配置请求参数
      .request<UserTeamInfoInterface>({
        method: "GET",
        api: "focus.getUserTeamInfo" // 请求的API接口名称
      })
      // 请求成功后的处理
      .then((res) => {
        return res; // 返回请求结果
      })
      // 请求失败后的处理
      .catch((err) => {
        message.error(err.message); // 显示错误信息
      })
  );
}
